import type React from "react";
import type { LabeledValue } from "antd/lib/select";

import type { TestItem } from "@/components/DetectItem";
import type { CustomerQuestionnaire } from "@/pages/Assessment/data";
import type { CustomerInfoHm, CustomerInfoSummary} from "@/pages/Customer/AddCustomer/data";
import { CustomerInfo, ServiceStatus } from "@/pages/Customer/AddCustomer/data";
import type { CustomerPlan } from "@/pages/Customer/CustomerDetail/components/HealthProgram/data";
import type { ExamRecord } from "@/pages/Customer/CustomerDetail/components/MedicalRecords/data";
import type { UserInfoSummary } from "@/pages/Customer/TeamManage/data";
import { UserInfo } from "@/pages/Customer/TeamManage/data";
import type { ServiceItem } from "@/pages/Service/Services/components/ServiceItem/data";

export interface IUserInfo {
  org: string,
  name: string
};

export enum ServiceTaskServiceTypeEnum {
  '我处理的' = 1,
  '我创建的' = 2,
  '我转交的' = 3,
  '我客户的' = 4,
  '所有任务' = 5,
};

export type ServiceTaskServiceTypeKey = keyof typeof ServiceTaskServiceTypeEnum;
export type ServiceTaskServiceType = 1 | 2 | 3 | 4 | 5;

export enum ServiceTaskStatusEnum {
  '待处理' = 1,
  '处理中' = 2,
  '已完成' = 3,
  '已关闭' = 4
};
export type ServiceTaskStatueKey = keyof typeof ServiceTaskStatusEnum;
export type ServiceTaskStatus = 1 | 2 | 3 | 4;

export enum ServiceTaskProcessorTypeEnum {
  '个人' = '1',
  '团队' = '2'
};
export type ServiceTaskProcessorType = '1' | '2';

export enum ServiceResultMedia {
  '电话' = 1,
  '微信',
  '短信',
  '线下'
};

export enum ServiceTaskLogOperationsEnum {
  'CREATE' = 1,
  'PROCESS',
  'SAVE',
  'SUBMIT',
  'CLOSE',
  'EDIT',
  'MOVE'
}
export type ServiceTaskLogOperations = keyof typeof ServiceTaskLogOperationsEnum;

export type ServiceTaskLog = {
  body: string;
  createTime: string;
  title: string;
  operations: ServiceTaskLogOperations;
};

export type ServiceTaskPushContent = {
  name: string;
  data: string;
  pushMode: string;
};

export type ServiceResult = {
  address?: string;
  lat?: string;
  lng?: string;
  customerQuestionnaireList?: CustomerQuestionnaire[];
  examData?: TestItem[];
  examDataIds: string;
  examReport?: ExamRecord;
  examRecordId: number;
  files: string;
  handler?: UserInfoSummary;
  id: number;
  media: number;
  mediaResult: number;
  msq: number;
  pushMethod: string;
  pushTemplate: string;
  remark: string;
  serviceOverview: string;
  serviceSolution?: CustomerPlan;
  serviceSolutionId: number;
  submitTime: number;
};

export type ServiceTask = {
  canShow?: boolean;
  createUserInfo: IUserInfo;
  customerId: string;
  customerInfoSummary: CustomerInfoSummary;
  customerQuestionnaireList?: CustomerQuestionnaire[];
  dataSource: string;
  desc: string;
  groupType: string;
  handlerInfo: IUserInfo;
  id: number;
  img: string;
  interval: number;
  media: number;
  mediaResult: number;
  moveUserInfo: IUserInfo;
  msq?: any;
  plan: string;
  planningTimeB: string;
  planningTimeE: string;
  processTimeB: string;
  processTimeE: string;
  closeTime: string;
  processorId: string;
  processorInfo: IUserInfo;
  processorType: ServiceTaskProcessorType;
  pushContent: ServiceTaskPushContent;
  remark: string;
  serviceItemIds: string;
  serviceItems: ServiceItem[];
  serviceResult: ServiceResult;
  simultaneousTasks: string;
  sort: number;
  status: ServiceTaskStatus;
  tempData: string;
  testData: any;
  times: number;
};

export type ServiceTaskInfo = {
  id: number;
  address?: string;
  closeTime: string;
  createUserId: string;
  createUserInfo: IUserInfo;
  customerId?: string;
  customerInfo: CustomerInfoHm;
  customerInfoSummary: CustomerInfoSummary;
  closerInfo: IUserInfo;
  description: string;
  groupType: string;
  handler: string;
  handlerInfo: IUserInfo;
  hasRelatedTask: boolean;
  isLate: boolean;
  moveUserId: string;
  moveUserInfo: IUserInfo;
  planningTimeB: string;
  planningTimeE: string;
  processTimeB: string;
  processTimeE: string;
  processorId: string;
  processorInfo: IUserInfo;
  processorType: ServiceTaskProcessorType;
  serviceItemNames: string[];
  serviceItems: ServiceItem[];
  status: ServiceTaskStatus;
  // 新增字段，判断是任务视图按键是否显示
  moveButtonShow?: boolean | null,
  createRelationTaskButtonShow?: boolean | null,
  closeButtonShow?: boolean | null,
  startHandlerButtonShow?: boolean | null,
  continueHandlerButtonShow?: boolean | null,
  updateButtonShow?: boolean | null;
};

export type ServiceTaskRemindSchedule = {
  timeType: string;
  remindTimeSettingNum: string;
  remindTimeSettingType: string;
}
export type BatchCreateTaskTableData = {
  temId: number;
  processor: LabeledValue;
  processorId: React.Key;
  processorType: ServiceTaskProcessorType;
  planningTime: [string, string];
  planningTimeB: string;
  planningTimeE: string;
  serviceItemIds: React.Key[];
  serviceItems: ServiceItem[];
  times?: number;
  interval?: number;
  desc: string;
  groupType?: string;
  customerQuestionnaireList?: CustomerQuestionnaire[];
  serviceTaskRemindScheduleList?: ServiceTaskRemindSchedule[];
};

export type ServiceTaskNum = {
  dateTime: string;
  status: number;
  taskNum: number;
};
